import React from 'react';
import { Container } from '@mui/material';
import dynamic from 'next/dynamic';
import LoadingItem from '../_common/Skeleton/stock';
// import PopularFunds from './PopularFunds';

const PopularFunds = dynamic(() => import('./PopularFunds'),
  { loading: () => <LoadingItem sx={{ mt: 3 }} /> })

const Funds = ({ data }) => {

  return <PopularFunds data={data} />
};

export default Funds;
